module.exports = __webpack_public_path__ + "img/advanced3.c3a4b1a4.png";